import React, { useEffect } from "react";
import Footer from "../Footer";
import ContactForm from "./ContactForm";
import Navbar from "../Navbar";

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white-50 min-h-screen flex flex-col">
      {/* Navbar at the top */}
      <div className="lg:mx-[40px]">
        <Navbar />
      </div>

      {/* Centered Content */}
      <div className="flex-grow flex items-center justify-center">
        <div className="flex lg:flex-row flex-col gap-4">
          <div className="flex flex-col gap-8">
            <ContactForm />
          </div>
        </div>
      </div>

      {/* Footer at the bottom */}
      <Footer />
    </div>
  );
};

export default ContactUs;
